import React from "react";

// reactstrap components
import {
    Col,
    Alert,
    Table,
    Badge,
    Button,
    Modal,
} from "reactstrap";
import NumberFormat from 'react-number-format';
import CreditApprovalDataService from "../../services/CreditApprovalDataService";

class CreditApprovals extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            toBeApproved: {},
        }
        this.CreditApprovalDataService = new CreditApprovalDataService();
    }

    toggleModal = (creditApproval) => {
        this.props.toggleModal("notificationModal", "approve", creditApproval)
    }

    toggleModals = (state, creditApproval) => {
        this.setState({
            [state]: !this.state[state],
            toBeApproved: creditApproval,
        });
    };

    handleDisableCreditApproval() {
        this.CreditApprovalDataService.disable(this.state.creditApprovalToDisabled)
            .then((data) => {
                this.handleResponse(data, "Produk berhasil dinonaktifkan");
            });
    }

    handleResponse(data, successMessage) {
        if (data.header.status_code !== 200) {
            let errorMessages = []
            data?.data?.map((data) => {
                return errorMessages.push(data?.error_message)
            })
            this.setState({ errorMessages: errorMessages })
        } else {
            this.toggleModals("notificationModal")
            this.props.setSuccessMessage(successMessage)
            this.setState({ currentCreditApproval: {} })
            this.props.fetchData()
        }
    }

    handleApprove(status) {
        this.CreditApprovalDataService.approveCredit(this.state.toBeApproved.Id, status)
            .then((res) => {
                if (res.errorMessage) {
                    this.props.setErrorMessage(res.errorMessage);
                } else {
                    this.props.setSuccessMessage(`Kredit berhasil ${status == 'approve' ? 'disetujui' : 'ditolak'}.`)
                    this.props.fetchData()
                }
                this.toggleModals("notificationModal");
                setTimeout(() => {
                    this.setState({ errorMessage: undefined, successMessage: undefined, })
                }, 5000);
            })
    }

    render() {
        return (
            <Table className="align-items-center table-flush" responsive>
                {this.state.errorMessage && (
                    <Col xs="12" className="mt-5">
                        <Alert color="danger">
                            {this.state.errorMessage}
                        </Alert>
                    </Col>
                )}
                <thead className="thead-light">
                    <tr>
                        <th scope="col">ID Report</th>
                        <th scope="col">Kredit</th>
                        <th scope="col">Total Pinjaman</th>
                        <th scope="col">Cicilan per Bulan</th>
                        <th scope="col">Tenor Pinjaman</th>
                        <th scope="col">Tenor Pinjaman Berjalan</th>
                        <th scope="col">NIK</th>
                        <th scope="col">Nama</th>
                        <th scope="col">Status</th>
                        <th scope="col" />
                    </tr>
                </thead>
                <tbody>
                    {this.props.creditApprovals.length > 0 && this.props.creditApprovals.filter(creditApproval => creditApproval).map((creditApproval) => (
                        <tr>
                            <th scope="row"> {creditApproval.Id} </th>
                            <td> {creditApproval.KreditName} </td>
                            <td> <NumberFormat
                                value={creditApproval.TotalAmount}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'Rp.'} suffix={',00'} /> </td>
                            <td> {creditApproval.Cicilan} </td>
                            <td> {creditApproval.TotalInstallment} </td>
                            <td> {creditApproval.CurrentInstallment} </td>
                            <td> {creditApproval.Nik} </td>
                            <td> {creditApproval.Nama} </td>
                            <td>
                                <Badge
                                    color={creditApproval.StatusString === 'new' ? "info" : (creditApproval.StatusString === 'rejected' ? "danger" : "info")}>
                                    {creditApproval.StatusString}
                                </Badge>
                            </td>
                            <td>
                                <Button
                                    color="primary"
                                    type="button"
                                    onClick={() => this.toggleModals("notificationModal", creditApproval)}
                                    size="sm">
                                    Setujui/Tolak</Button>
                                <Modal
                                    className="modal-dialog-centered modal-info"
                                    contentClassName="bg-gradient-primary"
                                    isOpen={this.state.notificationModal}
                                    toggle={() => this.toggleModals("notificationModal")}
                                >
                                    <div className="modal-header">
                                        <button
                                            aria-label="Close"
                                            className="close"
                                            data-dismiss="modal"
                                            type="button"
                                            onClick={() => this.toggleModals("notificationModal")}
                                        >
                                            <span aria-hidden={true}>×</span>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="py-3 text-center">
                                            <i className="ni ni-bell-55 ni-3x" />
                                            <h4 className="heading mt-4">Anda akan menyetujui kredit berikut</h4>
                                            <p>
                                                Nama kredit <b>{this.state.toBeApproved?.KreditName}</b> <br />
                                            </p>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <Button
                                            className="text-white ml-auto"
                                            color="link"
                                            data-dismiss="modal"
                                            type="button"
                                            onClick={() => this.toggleModals("notificationModal")}
                                        >
                                            Batal
                                        </Button>
                                        <Button
                                            className="btn"
                                            color="success"
                                            type="button"
                                            onClick={() => this.handleApprove('approve')}
                                        >
                                            Setujui
                                        </Button>
                                        <Button
                                            className="btn"
                                            color="danger"
                                            type="button"
                                            onClick={() => this.handleApprove('reject')}
                                        >
                                            Tolak
                                        </Button>
                                    </div>
                                </Modal>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    };
}

export default CreditApprovals;
